@if (route(); as route) {
  @if (route.length > 0) {
    <div
      class="menu-child"
      data-testid="item"
      matTooltipPosition="right"
      [class.last]="last()"
      [class.show]="show()"
      [class.expanded]="expanded()"
      [matTooltip]="itemTooltip() ?? ''"
    >
      <a
        class="link"
        title=""
        [class.active]="active()"
        [class.expanded]="expanded()"
        [routerLink]="route"
      >
        @if (expanded()) {
          {{ label() }}
        }
      </a>
    </div>
  }
}
@if (view(); as view) {
  @if (view.length !== 0) {
    <button
      class="menu-child"
      data-testid="item"
      title=""
      matTooltipPosition="right"
      [class.last]="last()"
      [class.show]="show()"
      [class.expanded]="expanded()"
      [matTooltip]="itemTooltip() ?? ''"
      (click)="navigate()"
    >
      <span
        class="content"
        [class.active]="active()"
      >
        @if (expanded()) {
          {{ label() }}
        }
      </span>
    </button>
  }
}
<div
  class="tree-indicator"
  [class.expanded]="expanded()"
>
  <div
    class="vertical-line"
    [class.last]="last()"
    [class.first]="first()"
  ></div>
  <div
    class="horizontal-line"
    [class.last]="last()"
    [class.first]="first()"
    [class.show]="show()"
    [class.dim-active]="active() && isDimHighlight()"
  ></div>
</div>
